module.exports = __webpack_public_path__ + "static/scale-model-of-broken-arrow-historical-soc-in-broken-arrow-oklahoma-adcb743f52a9a1ea0ef599c98b2165cd.png";